// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RotaProtegida, RotaLogada, RotaPremium, RotaAdmin } from './components/Guards';
import Footer from './components/Footer';

function AppLayout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

// Páginas públicas
import LandingPage      from './pages/LandingPage';
import Login            from './pages/Login';
import Cadastro         from './pages/Cadastro';
import RecuperarSenha   from './pages/RecuperarSenha';
import RedefinirSenha   from './pages/RedefinirSenha';
import Planos           from './pages/Planos';
import Checkout         from './pages/Checkout';
import TermosDeUso      from './pages/TermosDeUso';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';

// Páginas de assinante (Básico+)
import Veiculos         from './pages/Veiculos';
import VeiculoDetalhe   from './pages/VeiculoDetalhe';
import Produtos         from './pages/Produtos';

// Páginas Premium
import Vender           from './pages/Vender';
import MinhasSolicitacoes from './pages/MinhasSolicitacoes';
import MeusAnuncios       from './pages/MeusAnuncios';

// Perfil
import Perfil           from './pages/Perfil';
import MinhaAssinatura  from './pages/MinhaAssinatura';

// Admin
import AdminDashboard   from './pages/admin/Dashboard';
import AdminUsuarios    from './pages/admin/Usuarios';
import AdminVeiculos    from './pages/admin/Veiculos';
import AdminVeiculoForm from './pages/admin/VeiculoForm';
import AdminSolicitacoes from './pages/admin/Solicitacoes';
import AdminSolicitacaoDetalhe from './pages/admin/SolicitacaoDetalhe';
import AdminCampanhas   from './pages/admin/Campanhas';
import AdminProduto     from './pages/admin/Produto';
import AdminAssinaturas from './pages/admin/Assinaturas';

import './styles/global.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout>
        <Routes>
          {/* Públicas */}
          <Route path="/"                    element={<LandingPage />} />
          <Route path="/login"               element={<Login />} />
          <Route path="/cadastro"            element={<Cadastro />} />
          <Route path="/recuperar-senha"     element={<RecuperarSenha />} />
          <Route path="/redefinir-senha"     element={<RedefinirSenha />} />
          <Route path="/planos"              element={<Planos />} />
          <Route path="/checkout"            element={<RotaLogada><Checkout /></RotaLogada>} />
          <Route path="/termos"              element={<TermosDeUso />} />
          <Route path="/privacidade"         element={<PoliticaPrivacidade />} />

          {/* Assinante Básico+ */}
          <Route path="/veiculos"            element={<RotaProtegida><Veiculos /></RotaProtegida>} />
          <Route path="/veiculos/:id"        element={<RotaProtegida><VeiculoDetalhe /></RotaProtegida>} />
          <Route path="/produtos"            element={<RotaProtegida><Produtos /></RotaProtegida>} />

          {/* Premium */}
          <Route path="/vender"              element={<RotaPremium><Vender /></RotaPremium>} />
          <Route path="/minhas-solicitacoes" element={<RotaPremium><MinhasSolicitacoes /></RotaPremium>} />
          <Route path="/meus-anuncios"        element={<RotaPremium><MeusAnuncios /></RotaPremium>} />

          {/* Perfil */}
          <Route path="/perfil"              element={<RotaProtegida><Perfil /></RotaProtegida>} />
          <Route path="/minha-assinatura"    element={<RotaProtegida><MinhaAssinatura /></RotaProtegida>} />

          {/* Admin */}
          <Route path="/admin"               element={<RotaAdmin><AdminDashboard /></RotaAdmin>} />
          <Route path="/admin/usuarios"      element={<RotaAdmin><AdminUsuarios /></RotaAdmin>} />
          <Route path="/admin/veiculos"      element={<RotaAdmin><AdminVeiculos /></RotaAdmin>} />
          <Route path="/admin/veiculos/novo" element={<RotaAdmin><AdminVeiculoForm /></RotaAdmin>} />
          <Route path="/admin/veiculos/:id"  element={<RotaAdmin><AdminVeiculoForm /></RotaAdmin>} />
          <Route path="/admin/solicitacoes"  element={<RotaAdmin><AdminSolicitacoes /></RotaAdmin>} />
          <Route path="/admin/solicitacoes/:id" element={<RotaAdmin><AdminSolicitacaoDetalhe /></RotaAdmin>} />
          <Route path="/admin/campanhas"     element={<RotaAdmin><AdminCampanhas /></RotaAdmin>} />
          <Route path="/admin/produto"       element={<RotaAdmin><AdminProduto /></RotaAdmin>} />
          <Route path="/admin/assinaturas"   element={<RotaAdmin><AdminAssinaturas /></RotaAdmin>} />

          <Route path="*" element={<LandingPage />} />
        </Routes>
        </AppLayout>
      </BrowserRouter>
    </AuthProvider>
  );
}
